module.exports = __webpack_public_path__ + "static/media/MelilloLogo.70313afd.png";